import { useEffect, useRef } from "react";
import { connect } from "react-redux";
import momentJalaali from "moment-jalaali";

import { CalculatePriceWorker } from "../../../../../../helper/worker/CalculatePriceWorker";
import { CalculatePriceReserveWorker } from "../../../../../../helper/worker/CalculatePriceReserveWorker";
import { CanOrderCalculateTravelCost } from "../../../../../../helper/worker/CanOrderCalculateTravelCost";
import { SetEditRequestForceCalculateCost } from "../../../../../../Redux/actions/actionNames";


// ---------- helpers ----------

const toUnix = (date) => {
  if (!momentJalaali(date).isValid()) return 0;
  return momentJalaali(Number(date)).unix();
};

const isScheduled = (point) =>
  Number(point?.scheduleDateBefore) > 0 || Number(point?.scheduleDateAfter) > 0;

const buildDropWithSchedule = (drop) => ({
  address: drop.address,
  adresss_loc: drop.adresss_loc,
  block: drop.block,
  floor: drop.floor,
  id: drop.id,
  recieverFullName: drop.recieverFullName,
  recieverPhoneNumber: drop.recieverPhoneNumber,
  unit: drop.unit,
  scheduleDateAfter: toUnix(drop.scheduleDateAfter),
  scheduleDateBefore: toUnix(drop.scheduleDateBefore),
});

const buildBasePayload = (props) => ({
  customerId: props.customerId,
  customerType: props.person ? "individual" : "business",
  orderId: props.id,
  serviceactiveVehicleType: props.serviceactiveVehicleType,
  serviceoptions: props.serviceoptions,
  auto: props.auto,
  driveroptions: props.driveroptions,
  auto_activeVehicleType: props.auto_activeVehicleType,
  manual_activeVehicleType: props.manual_activeVehicleType,
});

// ---------- component ----------

const App = (props) => {
  const prevLocations = useRef(null);

  const calculate = (p) => {
    const base = buildBasePayload(p);

    const scheduled =
      isScheduled(p.pickup) || isScheduled(p.firstDropOff);

    const payload = scheduled
      ? {
          ...base,
          pickup: {
            address: p.pickup.address,
            scheduleDateAfter: toUnix(p.pickup.scheduleDateAfter),
            scheduleDateBefore: toUnix(p.pickup.scheduleDateBefore),
          },
          pickupadresss_loc: p.pickupadresss_loc,
          firstDropOff: {
            address: p.firstDropOff.address,
            scheduleDateAfter: toUnix(p.firstDropOff.scheduleDateAfter),
            scheduleDateBefore: toUnix(p.firstDropOff.scheduleDateBefore),
          },
          firstDropOffadresss_loc: p.firstDropOffadresss_loc,
          otherdropOffs: p.otherdropOffs.map(buildDropWithSchedule),
        }
      : {
          ...base,
          pickup: { address: p.pickup.address },
          pickupadresss_loc: p.pickupadresss_loc,
          firstDropOff: { address: p.firstDropOff.address },
          firstDropOffadresss_loc: p.firstDropOffadresss_loc,
          otherdropOffs: p.otherdropOffs,
        };

    if (scheduled) {
      CalculatePriceReserveWorker(payload, props.dispatch);
    } else {
      CalculatePriceWorker(payload, props.dispatch);
    }
  };

  // ---------- initial mount ----------
  useEffect(() => {
    calculate(props);
    prevLocations.current = props;
  }, []);

  // ---------- watch location changes ----------
  useEffect(() => {
    if (!prevLocations.current) return;

    CanOrderCalculateTravelCost(
      {
        pickupadresss_loc: prevLocations.current.pickupadresss_loc,
        firstDropOffadresss_loc:
          prevLocations.current.firstDropOffadresss_loc,
        otherdropOffs: prevLocations.current.otherdropOffs.map(
          (i) => ({ ...i.adresss_loc })
        ),
      },
      {
        pickupadresss_loc: props.pickupadresss_loc,
        firstDropOffadresss_loc: props.firstDropOffadresss_loc,
        otherdropOffs: props.otherdropOffs.map((i) => ({
          ...i.adresss_loc,
        })),
      },
      (shouldCall) => {
        if (shouldCall || props.forceCalculateCost) {
          props.dispatch(SetEditRequestForceCalculateCost(false));
          calculate(props);
        }
      }
    );

    prevLocations.current = props;
  }, [
    props.pickupadresss_loc,
    props.firstDropOffadresss_loc,
    props.otherdropOffs,
    props.forceCalculateCost,
  ]);

  return null;
};

export default connect((state) => ({
  forceCalculateCost: state.EditOrder.forceCalculateCost,
  person: state.EditOrder.editOrder.customer.person,
  serviceactiveVehicleType:
    state.EditOrder.editOrder.service.activeVehicleType,
  serviceoptions: state.EditOrder.editOrder.service.options,
  auto: state.EditOrder.editOrder.driver.auto,
  driveroptions: state.EditOrder.editOrder.driver.options,
  auto_activeVehicleType:
    state.EditOrder.editOrder.driver.auto_driver.auto_activeVehicleType || {},
  manual_activeVehicleType:
    state.EditOrder.editOrder.driver.manual_driver.manual_activeVehicleType || {},
  pickup: state.EditOrder.editOrder.pickup,
  pickupadresss_loc: state.EditOrder.editOrder.pickup.adresss_loc,
  firstDropOff: state.EditOrder.editOrder.dropOffs.firstDropOff,
  firstDropOffadresss_loc:
    state.EditOrder.editOrder.dropOffs.firstDropOff.adresss_loc,
  otherdropOffs: state.EditOrder.editOrder.dropOffs.otherDropOffs,
  id: state.EditOrder.editOrder.id,
  customerId: state.ViewTravel.pureData.customerId,
}))(App);
